<template>
  <div class="sys-list">

    <div v-if="hidePrice" class="price-wrap">

      <div class="truth-price" v-if="realPrice">
        <span>{{ priceSeparator(realPrice) }}</span>
        <span class="mini_shelf_price" v-if="shelfPrice">({{ priceSeparator(shelfPrice) }})</span>

        <!-- 折扣 标签 -->
					<div
						v-if="userDiscountStr"
						class="sign primary"
					>
						{{ userDiscountStr }}
					</div>

					<!-- 包邮 标签 -->
          <div v-if="isFreeShipping" class="sign">
            {{ $t('message.goods.sign.freepostage') }} 
          </div>
          
          <!-- @todo 紧急问题修复 ，美元化以后就不存在含税一说了 -->
	        <!-- 含税 标签 -->
					<div class="sign"  v-if="false">
            {{ $t('message.goods.sign.freetax') }}
          </div>
					
					<!-- 不退不换标签 -->
					<div v-if="!supportRefund" class="sign">
            {{ $t('message.goods.sign.supportRefund') }}
					</div>
				

      </div>

      <!-- 划价 -->
      <!-- <div class="origin-price-span" v-if="showOriginalPrice">
        {{ priceSeparator(originalPrice) }}
      </div> -->

      <!-- 含邮含税 -->
      <div v-if="miniOrgAmountMoney" class="origin-price">
        <!-- 划价 -->
        <span class="origin-price-span">{{ priceSeparator(originalPrice) }}</span>
        <!-- @todo 紧急问题修复 ，美元化以后就不存在含税一说了 -->
        <span v-if="false">
         （{{ $t('message.goods.sign.freeShippingTaxInclude') }}）
          <!-- {{ lanEnv() ?'（含邮含税）': '（Free Shipping&Tax included）' }} -->
        </span>
      </div>
      <!-- 平台服务费说明文案 -->
      <div class="service-fee-info" v-if="serviceFeeInfo && serviceFeeInfo.length">
         {{ serviceFeeText }}
         <span v-if="serviceFeeInfo[1]">{{ serviceFeeInfo[1] }}</span>
      </div>
      <div class="price-tips">
        {{ $t('message.goods.sign.priceTips') }}
        <!-- {{  lanEnv()? '售卖价格或因汇率波动有所浮动': 'Due to fluctuating exchange rates, this price may fluctuate as well.' }} -->
      </div>
      <!-- <div class="origin-price-span" v-if="miniOrgAmountMoney">{{ priceSeparator(originalPrice) }}</div> -->
    </div>

    <!-- 商品名称 -->
    <div class="good-name">{{name}}</div>
    <!-- <div class="sales-num">销量: {{salesNum}}</div> -->
  </div>
</template>
<script>

import { priceSeparator } from '@/utils/formatUtil';
export default {
    props: {
        minShelfAmountMoney: Object,
        miniAmountMoney: Object,
        miniOrgAmountMoney: Object,
        userDiscountStr: String,
        userDiscount: String,
        isFreeShipping: Number,
        isFreeTaxes: Number,
        name: String,
        salesNum: Number,
        hidePrice: Boolean,
        hideAddCart: Number,
        selfSupport: Number,
        supportRefund: Number,
        serviceFeeInfo: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            priceSeparator
        }
    },
    computed: {
        serviceFeeText() {
            if (this.serviceFeeInfo && this.serviceFeeInfo.length) {
                const text = this.serviceFeeInfo[1]
                if (text) {
                    const index = this.serviceFeeInfo[0].indexOf(text)
                    if (index !== -1) {
                        return this.serviceFeeInfo[0].substring(0, index)
                    }
                }
                return this.serviceFeeInfo[0]
            }
        },
        titleWidth() {
            return !this.hidePrice ? '78vw' : '';
        },

        shelfPrice(){
          if( !this.minShelfAmountMoney ){
            return null;
          }
          const { symbol, number } = this.minShelfAmountMoney;
          return number ? `${symbol}${Number(number).toFixed(2)}` : '';
        },

        realPrice() {
            // 真实价格
            const { symbol, number } = this.miniAmountMoney;
            return number ? `${symbol} ${Number(number).toFixed(2)}` : '';
        },
        originalPrice() {
            // 原价
            const { symbol, number } = this.miniOrgAmountMoney;
            return number ? `${symbol} ${Number(number).toFixed(2)}` : '';
        },
        showOriginalPrice() {
          return this.userDiscountStr;
            // const miniAmountMoney = (this.miniAmountMoney || {}).number;
            // const miniOrgAmountMoney = (this.miniOrgAmountMoney || {}).number;
            // return Number(miniAmountMoney) < Number(miniOrgAmountMoney);
        },
        formatUserDisCount() {
            if (this.userDiscountStr) {
                const disCount = Number(this.userDiscountStr) * 10;
                if (this.userDiscountStr.toString().includes('.')) {
                    return disCount.toFixed(1);
                }
                return disCount;
            }
            return NaN;
        }
    }
};
</script>

<style lang="less" scoped>
.sign {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 32px;
  height: 18px;
  margin-right: 4px;
  padding: 0 3px;
  font-size: 11px;
  line-height: 1;
  color: #b4282d;
  border-radius: 3px;
  border: 1px solid #b4282d;
  white-space: nowrap;
  font-family: 'PingFangSC-Semibold';
  transform: scale(.9);
  transform-origin: center center;
  &.primary {
    border: 0;
    background-color: #b4282d;
    color: #fff;
  }
}
.origin-price {
  margin-top: 4px;
  font-size: 12px;
  color: #6e7784;
  font-family: 'PingFang SC';
  &-span {
    text-decoration: line-through;
  }
}
.price-tips {
  font-family: 'PingFang SC';
  margin-top: 8px;
  font-size: 12px;
  color: #6e7784;
}
.service-fee-info{
    font-family: 'PingFang SC';
    font-size: 12px;
    color: #333333;
    padding: 10px 0 0;
    span{
        color: #F37C47;
    }
}


.mini_shelf_price{
  color: #aaa;
  font-size: 12px;
  font-weight: normal;
  font-family: 'PingFang SC';
}

img {
  display: block;
}
.sys-list {
  box-sizing: border-box;
  width: 100%;
  position: relative;
  padding: 12px;
  background-color: #fff;
}
.share {
  width: 48px;
  height: 44px;
  background: #f5f2ee;
  border-radius: 100px 0 0 100px;
  position: absolute;
  top: 12px;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Regular;
  font-size: 11px;
  color: #666666;
  img {
    display: block;
    width: 18px;
    height: 18px;
  }
  span {
    margin-top: 4px;
  }
}
.price-wrap {
  min-height: 46px;
  font-family: PingFangSC-Semibold;
  font-size: 22px;
  color: #b4282d;
  text-align: left;
  .truth-price {
    min-height: 30px;
    height: auto;
    margin-right: 12px;
    font-family: "TradeGothicLT-Bold";
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
    span{
      margin-right: 4px;
    }
  }
  .origin-price-span{
    margin-top: 4px;
    font-size: 12px;
    color: #6e7784;
    text-align: left;
    text-decoration: line-through;
    font-family: "TradeGothicLT";
  }
}
.goods-title {
  .self-support{
    text-align: center;
    display: inline;
    height: 16px;
    line-height: 16px;
    padding: 0 2.5px;
    margin-right: 5px;
    border-radius: 2px;
    font-family: PingFangSC-Regular;
    font-size: 10px;
    color: #F40009;
    vertical-align: middle;
  }
  .is-self-support{
    border: 0.5px solid #FF3239;
    background: #fff;
  }
  .not-self-support{
    background: rgba(255,201,203, .35);
  }
  .self-name{
    display: inline;
    vertical-align: middle;
  }
  margin-top: 4px;
  font-size: 16px;
  line-height: 22px;
  color: #161a1a;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.sales {
  margin-top: 8px;
  font-size: 13px;
  color: #a4a4a4;
}
.good-name{
  text-align: left;
  font-size: 16px;
  color: #161A1A;
  margin: 12px 0 8px 0;
  font-family: "TradeGothicLT-Bold";
}
.sales-num{
  text-align: left;
  font-size: 13px;
  color: #A4A4A4;
  margin: 0 0 12px 0;
}
</style>
